import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ElvisConnectDash } from 'components/svg/ElvisConnectDash';
import { EurofinsLogoDash } from 'components/svg/EurofinsLogoDash';
import { NavigationContent } from './NavigationContent';

interface DesktopHeaderProps {
  navigationProps: any;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  navigationProps
}) => {
  return (
    <>
      <Typography
        variant="h6"
        color="#fff"
        noWrap
        component="div"
        sx={{ mr: 2, flexGrow: 1, display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}
      >
        <EurofinsLogoDash />
      </Typography>

      <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
        <div style={{ marginRight: '16px', backgroundColor: '#fff', borderRadius: '40px' }}>
          <ElvisConnectDash />
        </div>

        <NavigationContent {...navigationProps} isMobile={false} />        
      </Box>
    </>
  );
};